// Test authentication page
import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../firebaseConfig.js';
import { incrementCreatorCount } from '../utils/incrementCreatorCount.js';

const TestAuth = ({ onNavigate }) => {
  const [email, setEmail] = useState('testbrand@example.com');
  const [password, setPassword] = useState('password123');
  const [result, setResult] = useState('');

  const testSignup = async () => {
    try {
      setResult('Creating user...');
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      setResult('Creating Firestore profile...');
      await setDoc(doc(db, 'users', user.uid), {
        email: email,
        userType: 'brand',
        status: 'approved',
        companyName: 'Test Company',
        firstName: 'Test',
        lastName: 'User',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      
      // Increment creator count (this is a new creator)
      await incrementCreatorCount();
      
      setResult('✅ Test brand created successfully!');
    } catch (error) {
      setResult('❌ Error: ' + error.message);
    }
  };

  const testLogin = async () => {
    try {
      setResult('Logging in...');
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      setResult('✅ Login successful! User ID: ' + userCredential.user.uid);
      
      // Redirect to dashboard after successful login
      setTimeout(() => {
        onNavigate('dashboard');
      }, 1000);
    } catch (error) {
      setResult('❌ Login error: ' + error.message);
    }
  };

  const testSignOut = async () => {
    try {
      await signOut(auth);
      setResult('✅ Signed out successfully');
    } catch (error) {
      setResult('❌ Sign out error: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Authentication Test</h1>
        
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
              />
            </div>
            
            <div className="space-x-4">
              <button
                onClick={testSignup}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                Test Signup
              </button>
              
              <button
                onClick={testLogin}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Test Login
              </button>
              
              <button
                onClick={testSignOut}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Test Signout
              </button>
            </div>
          </div>
        </div>
        
        {result && (
          <div className="bg-gray-100 p-4 rounded">
            <pre className="text-sm">{result}</pre>
          </div>
        )}
        
        <button
          onClick={() => onNavigate('login')}
          className="mt-4 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default TestAuth;
